import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Save, Clear } from '@material-ui/icons';
import Snackbar from "components/Snackbar/Snackbar.jsx";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.jsx";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";
import Globales from "utils/Globales";
import { designsApi } from "api/desings";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class ModalCancelarPedido extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
  
    }
  
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick()
    }
  }

  componentDidMount() {
    //console.log(this.props)
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  
 

 
  showNotification(mensaje, color) {
    var x = [];
    this.setState({ br: true, mensaje: mensaje, colorNotificacion: color });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      3000
    );
  }

  EliminarDisenoGuardado = async (id) => {
    let data = await designsApi.deleteDesign(this.props.idDiseno)

    if (!data.success) {
      this.showNotification(data.message, "danger")
    } else {
      this.props.eventClick(true)
    }
  }



 
  
 

  render() {
    const { classes, ...rest } = this.props;

  


    return (
      <div>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal
          }}
          open={this.props.Show}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.props.eventClick(false)}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              simple
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              onClick={() => this.props.eventClick(false)}
            >
              {" "}
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>Eliminar diseño</h4>
          </DialogTitle>
          <DialogContent id="classic-modal-slide-description" className={classes.modalBody}>
              <span>¿Estas seguro que deseas eliminar tu diseño?</span>
              <br/>
              {/* <span>Tienes hasta el {this.props.FechaParaCancelar} para cancelar o editar tu pedido.</span> */}
      
          </DialogContent>
          <DialogActions className={classes.modalFooter}>
            <Button onClick={() =>this.EliminarDisenoGuardado()} size="sm" color="danger" className="pull-right" round ><Save />&nbsp;Si, Eliminar</Button>
            <Button size="sm" color="github" className="pull-right" round onClick={() => this.props.eventClick(false)}><Clear />&nbsp;No, mantener</Button>
          </DialogActions>
        </Dialog>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div >
    );
  }
}

export default withStyles(modalStyle)(ModalCancelarPedido);